import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ChevronLeftRounded, ChevronRightRounded } from "@mui/icons-material";
import { Box, ButtonBase, ClickAwayListener, useMediaQuery, useTheme, } from "@mui/material";
import clsx from "clsx";
import { useCallback, useState } from "react";
import { useUpdateEffect } from "react-use";
import { UiTypography } from "../../ui_typography";
import { useStyles } from "./ui_sidebar.css";
export const UiSidebar = ({ ScreenSecondaryDrawerLabel, ScreenSecondary, isForceOpen, onCollapse, onExpand, disableAwayClick, }) => {
    const classes = useStyles();
    const [isOpened, setIsOpened] = useState(Boolean(isForceOpen));
    const theme = useTheme();
    const isLessThanMedium = useMediaQuery(theme.breakpoints.down("md"));
    const toggleDrawer = useCallback(() => {
        if (isOpened) {
            onCollapse && onCollapse();
            setIsOpened(false);
        }
        else {
            onExpand && onExpand();
            setIsOpened(true);
        }
    }, [isOpened, onCollapse, onExpand]);
    useUpdateEffect(() => {
        if (isForceOpen !== undefined) {
            setIsOpened(isForceOpen);
        }
    }, [isForceOpen]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { onClick: toggleDrawer, className: classes.open_drawer_button, children: _jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", children: [_jsx(ChevronLeftRounded, { color: "primary" }), _jsx(UiTypography, { variant: "h5", className: classes.open_drawer_button__text, children: ScreenSecondaryDrawerLabel || null })] }) }), isOpened && (_jsx(ClickAwayListener, { onClickAway: toggleDrawer, mouseEvent: disableAwayClick ? false : "onMouseUp", children: _jsx(Box, { className: clsx(classes.drawer, {
                        [classes["drawer--active"]]: isOpened,
                        [classes["drawer--inactive"]]: !isOpened,
                        [classes["drawer--absolute"]]: isLessThanMedium,
                    }), children: _jsxs(Box, { display: "flex", className: classes.drawer__inn, children: [_jsx(Box, { children: _jsx(ButtonBase, { onClick: toggleDrawer, color: "primary", className: classes.close_drawer_button, disableRipple: true, children: _jsx(ChevronRightRounded, { className: classes.close_drawer_button__icon, fontSize: "large", color: "primary" }) }) }), _jsx(Box, { className: classes.drawer__inn__content, children: ScreenSecondary })] }) }) }))] }));
};
//# sourceMappingURL=ui_sidebar.js.map